<div class="social-container" [style.margin-top]="marginTop">
  <ul class="social">
    @for (link of links; track link.url) {
      <li>
        <a [href]="link.url" [title]="link.title" target="_blank">
          <i [class]="link.iconClass"></i>
        </a>
      </li>
    }
  </ul>
</div>
